<template>
  <v-dialog
    v-model="getTariffEditModal"
    width="400"
    content-class="add-head-modal"
  >
    <v-card class="pt-11 pb-13 px-8 rounded-xl elevation-0 bg_sidebar">
      <p class="mb-6 font-20px dark-color--text">{{ $t("Tariffs.edit_tariff") }}</p>
      <div>
        <label class="mb-4 label sub--text">{{ $t("Tariffs.tariff_name") }}</label>
        <v-text-field
          solo
          outlined
          flat
          class="focus-input"
          hide-details="false"
          height="44px"
          v-model="form.name"
        ></v-text-field>
      </div>
      <div class="mt-5">
        <label class="mb-4 label sub--text">{{ $t("Owners.employees_count") }}</label>
        <v-text-field
          solo
          outlined
          flat
          class="focus-input mask-number"
          hide-details="false"
          height="44px"
          type="number"
          disabled
          v-model="form.max_employees_qty"
        ></v-text-field>
      </div>

      <div class="mt-5 pb-4 tariff-tab-2">

        <label class="mb-4 label sub--text">{{ $t("Tariffs.month_price") }} KZT</label>
        <v-text-field
          solo
          outlined
          flat
          class="focus-input mask-number"
          hide-details="false"
          height="44px"
          type="number"
          v-model="form.month_price"
        ></v-text-field>

      </div>
      <div class="error--text" v-if="err === true">
        {{ error }}
      </div>
      <div class="mt-6">
        <v-btn
          width="100%"
          height="44px"
          elevation="0"
          hide-selected="true"
          class="button"
          color="main_color white--text"
          @click="updateTariff"
        >
          {{ $t("Default.save") }}
        </v-btn>
        <v-btn
          width="100%"
          height="44px"
          elevation="0"
          hide-selected="true"
          class="button mt-2"
          color="sub white--text"
          @click="getTariffEditModal = false"
        >
          {{ $t("Default.cancel") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import {ref, watch} from "@vue/composition-api";
import {shortComputed} from "@/utility/helpers";
import {useStore} from "vuex-composition-helpers";
import {
  MutationTypes,
  DispatchTypes,
} from "@/store/modules/admin/tariffs/types";
import {VARIABLES} from "@/utility/variables";

export default {
  name: "getTariffEditModal",
  setup(props, {root}) {
    const store = useStore();
    const tab = ref(VARIABLES.DEFAULT_TAB);
    const error = ref("Тариф с таким названием уже существует");
    const err = ref(false);
    const form = ref({});
    const getTariffEditModal = shortComputed(
      {
        storeType: "tariffs",
        key: "getTariffEditModal",
      },
      MutationTypes.setTariffEditModal
    );

    const Tracking = watch(
      () => store.state.tariffs.tariff,
      (val) => {
        form.value = {...val};
        console.log(val, form.value);
      }
    );

    const updateTariff = () => {
      store
        .dispatch(DispatchTypes.editTariff, form.value)
        .then(() => {
          store.commit(MutationTypes.setTariffEditModal, false);
        })
        .catch((res) => {
          if (res.message.includes("tariffs_tariff_name_key")) {
            err.value = true;
          }
        });
    };

    return {
      store,
      getTariffEditModal,
      tab,
      form,
      updateTariff,
      error,
      err,
      Tracking,
    };
  },
};
</script>

<style>
.v-slide-group__prev {
  display: none !important;
}

.v-slide-group__next {
  display: none !important;
}

.v-item-group {
  background-color: transparent !important;
}
</style>